import {PopupButtonUntranslated} from "./popupTools";

export const DIALOGPARTS = {
    BUTTONS: {
        OK: {
            text: {id: "konf_OK", alternative: "OK"},
            closeAfter: true
        },
        CANCEL: {
            text: {id: "konf_Cancel", alternative: "Abbrechen"},
            closeAfter: true
        },
        YES: {
            text: {id: "konf_yes", alternative: "Ja"}
        },
        NO: {
            text: {id: "konf_no", alternative: "Nein"},
            color: "grey"
        },
        CONTINUE_TO_PAYMENT: {
            text: {id: "konf_continueToPayment", alternative: "weiter zu den Zahlungsdaten"}
        },
        BACKTOBASKET: {
            text: {id: "konf_BackToBasket", alternative: "zurück zum Warenkorb"},
            closeAfter: true
        }, CONTINUE_WITHOUT_LOGIN: {
            text: {id: "konf_ContinueWoLogin", alternative: "Weiter ohne Login"},
            closeAfter: true,
            color: "grey"
        }, LOGIN_OR_REGISTER: {
            text: {id: "konf_loginOrRegister", alternative: "Login / Anmelden"},
            closeAfter: true
        },
        DELETE: {
            text: {id: "konf_delete", alternative: "Löschen"},
            closeAfter: true
        },
        UNDO: {
            text: {id: "konf_undoButton", alternative: "Rückgängig"},
            closeAfter: true
        }
    },
    TITLES: {
        WARNING: {id: "konf_warning", alternative: "Achtung!"},
        ATTENTION: {id: "konf_Attention", alternative: "Vorsicht!"},
        MESSAGE_SENT: {id: "konf_messageSent", alternative: "Ihre Nachricht wurde versendet."},
        OK: {id: "konf_OK", alternative: "OK"},
        HINWEIS: {id: "konf_HINWEIS", alternative: "Hinweis"}
    }
};


export type DIALOGDEFINITION = {
    cssClass: string,
    titleUntranslated: { id: string, alternative: string },
    title?: string
    messageUntranslated: { id: string, alternative: string },
    message?
    buttons: PopupButtonUntranslated[]
}

function getDialogButton(buttonDefinition: {
    text: { id, alternative },
    closeAfter?,
    color?
}): PopupButtonUntranslated {

    return {
        closeAfter: buttonDefinition.closeAfter,
        color: buttonDefinition.color,
        text: "",
        textUntranslated: {alternative: buttonDefinition.text.alternative, id: buttonDefinition.text.id},
        callback: null
    }
}

export function getDialog(dialogName: string): DIALOGDEFINITION {
    if (DIALOGS[dialogName] === undefined) {
        return {
            titleUntranslated: {id: "notdef", alternative: dialogName},
            messageUntranslated: {id: "notdef", alternative: "dialog nicht gefunden!"},
            buttons: [getDialogButton(DIALOGPARTS.BUTTONS.OK)],
            cssClass: "warning"
        };
    }
    const dialog = DIALOGS[dialogName];
    return {
        buttons: [...(dialog.buttons.map(b => getDialogButton(b)))],
        cssClass: dialog.cssClass,
        messageUntranslated: dialog.message,
        titleUntranslated: dialog.title
    }
}


export const DIALOGS = {
    saveBeforeContinuing: {
        cssClass: "productChangeWarning",
        title: DIALOGPARTS.TITLES.ATTENTION,
        message: {
            id: "konf_warning_saveBeforProductChange",
            alternative: "Ihr Entwurf geht eventuell verloren. Wollen Sie ihn speichern?"
        },
        buttons: [DIALOGPARTS.BUTTONS.YES, DIALOGPARTS.BUTTONS.NO]
    },
    saveBeforeDraftLoading: {
        cssClass: "productChangeWarning",
        title: DIALOGPARTS.TITLES.ATTENTION,
        message: {
            id: "konf_warning_saveBeforeDraftLoading",
            alternative: "Sie haben die letzten Änderungen an Ihrem aktuellen Entwurf noch nicht abgespeichert. Möchten Sie diese speichern?"
        },
        buttons: [DIALOGPARTS.BUTTONS.YES, DIALOGPARTS.BUTTONS.NO]
    },

    // saveDraftFirst: {
    //     cssClass: "productChangeWarning",
    //     title: DIALOGPARTS.TITLES.ATTENTION,
    //     message: {id: "konf_saveDraftFirst", alternative: "Sie müssen zuerst den Entwurf speichern."},
    //     buttons: [DIALOGPARTS.BUTTONS.OK]
    // },

    errorSavingDraft: {
        cssClass: "notice warning badEmail",
        title: DIALOGPARTS.TITLES.WARNING,
        message: {
            id: "konf_errorSavingDrafts",
            alternative: "Oops, es ist was schief gegangen! Ihr Entwurf konnte nicht gespeichert werden! Bitte probieren Sie es nochmal."
        },
        buttons: [DIALOGPARTS.BUTTONS.OK]
    },
    errorInvalidBWColor: {
        cssClass: "notice warning badEmail",
        title: DIALOGPARTS.TITLES.WARNING,
        message: {
            id: "konf_errorWrongBWColor",
            alternative: "Die Produktfarbe ist nicht gültig. Bitte wählen Sie zuerst eine gültige Produktfarbe aus."
        },
        buttons: [DIALOGPARTS.BUTTONS.OK]
    },

    mailSentTo: {
        cssClass: "notice mailSent",
        title: DIALOGPARTS.TITLES.MESSAGE_SENT,
        message: {id: "konf_notice_yourMailWasSentTo", alternative: "Ihre Nachricht wurde versendet an"},
        buttons: [DIALOGPARTS.BUTTONS.OK]
    },
    mailSent: {
        cssClass: "notice mailSent",
        title: DIALOGPARTS.TITLES.MESSAGE_SENT,
        message: {
            id: "Kontakt_Okay",
            alternative: "Wir haben Ihre Mail erhalten. Sie erhalten innerhalb der nächsten 24 Stunden eine Antwort."
        },
        buttons: [DIALOGPARTS.BUTTONS.OK]
    },
    confirmNachbestellung: {
        cssClass: "notice confirmnachbestellung",
        title: {
            id: "konf_ConfirmNachbestellungTitle",
            alternative: "Möchten Sie dieses Produkt wirklich nachbestellen?"
        },
        message: {id: "konf_ConfirmNachbestellung", alternative: "Möchten Sie dieses Produkt wirklich nachbestellen?"},
        buttons: [DIALOGPARTS.BUTTONS.YES, DIALOGPARTS.BUTTONS.NO]
    },
    nachbestellungSent: {
        cssClass: "notice mailSent",
        title: DIALOGPARTS.TITLES.MESSAGE_SENT,
        message: {
            id: "Nachbestellung_Okay",
            alternative: "Wir haben Ihre Mail erhalten. Sie erhalten innerhalb der nächsten 24 Stunden eine Antwort."
        },
        buttons: [DIALOGPARTS.BUTTONS.OK]
    },

    mindestBestellMenge: {
        cssClass: "notice warning badEmail",
        title: DIALOGPARTS.TITLES.WARNING,
        message: {id: "konf_mindestBestellmenge", alternative: "Für dieses Produkt gibt es eine Mindestbestellmenge: "},
        buttons: [DIALOGPARTS.BUTTONS.OK]
    },
    maximalBestellMenge: {
        cssClass: "notice warning badEmail",
        title: DIALOGPARTS.TITLES.WARNING,
        message: {id: "konf_maximalBestellmenge", alternative: "Für dieses Produkt gibt es eine Maximalbestellmenge: "},
        buttons: [DIALOGPARTS.BUTTONS.OK]
    },
    warningNotLoggedIn: {
        cssClass: "notLoggedInSaves bordered",
        title: DIALOGPARTS.TITLES.ATTENTION,
        message: {
            id: "konf_warning_notLoggedIn",
            alternative: "Sie sind nicht eingeloggt. Ihre Entwürfe und hochgeladenen Logos werden"
                + " für Sie nur während dieser Sitzung vorhanden sein. Wenn Sie sich später einloggen, werden die Daten übernommen"
        },
        buttons: [
            DIALOGPARTS.BUTTONS.CONTINUE_WITHOUT_LOGIN,
            DIALOGPARTS.BUTTONS.LOGIN_OR_REGISTER
        ]
    },
    warningNotLoggedInFunctionLocked: {
        cssClass: "notLoggedInSaves bordered",
        title: DIALOGPARTS.TITLES.ATTENTION,
        message: {
            id: "konf_warning_notLoggedIn_functionLocked",
            alternative: "Sie sind nicht eingeloggt. Diese Funktion ist nur für registrierte Benutzer verfügbar."
        },
        buttons: [
            DIALOGPARTS.BUTTONS.CANCEL,
            DIALOGPARTS.BUTTONS.LOGIN_OR_REGISTER
        ]
    },
    warningNotLoggedInReLogin: {
        cssClass: "notLoggedInSaves bordered",
        title: DIALOGPARTS.TITLES.ATTENTION,
        message: {
            id: "konf_warning_notLoggedInRelogin",
            alternative: "Sie sind nicht eingeloggt. Ihre Entwürfe und hochgeladenen Logos werden"
                + " für Sie nur während dieser Sitzung vorhanden sein. Wenn Sie sich später einloggen, werden die Daten übernommen"
        },
        buttons: [
            DIALOGPARTS.BUTTONS.CONTINUE_WITHOUT_LOGIN,
            DIALOGPARTS.BUTTONS.LOGIN_OR_REGISTER
        ]
    },
    warningNotLoggedInExemplare: {
        cssClass: "notLoggedInSaves small",
        title: DIALOGPARTS.TITLES.ATTENTION,
        message: {
            id: "konf_warning_notLoggedIn_Exemplare",
            alternative: "Bitte loggen Sie sich ein, wenn Sie Ihre Exemplardaten dauerhaft speichern möchten."
                + " Wenn Sie sich nicht einloggen, verschwinden Ihre Exemplardaten, sobald Sie den Browser schließen."
        },
        buttons: [
            DIALOGPARTS.BUTTONS.CONTINUE_WITHOUT_LOGIN,
            DIALOGPARTS.BUTTONS.LOGIN_OR_REGISTER
        ]
    },
    orderSent: {
        cssClass: "notice orderSent",
        title: {id: "konf_orderReceived", alternative: "Vielen Dank für Ihre Bestellung!"},
        message: {
            id: "konfo_orderReceivedInfo",
            alternative: "Ihre Bestellung wurde an owayo übermittelt.<br> Sie erhalten demnächst eine Bestätigung per Email."
        },
        buttons: [DIALOGPARTS.BUTTONS.OK]
    },
    wkInkonsistent: {
        cssClass: "warning",
        title: DIALOGPARTS.TITLES.WARNING,
        message: {
            id: "konfi_fehler_wk_inkosistent",
            alternative: "Der Inhalt oder die Preise in Ihrem Warenkorb waren nicht auf dem neuesten Stand. <br>Wir haben Ihren Warenkorb deshalb aktualisiert. <br>Bitte prüfen Sie Ihren Warenkorb noch einmal sorgfältig, bevor Sie die Bestellung abschicken."
        },
        buttons: [DIALOGPARTS.BUTTONS.OK]
    },
    continueToPayment: {
        cssClass: "notice orderSent",
        title: {id: "konf_orderReceived", alternative: "Vielen Dank für Ihre Bestellung!"},
        message: {
            id: "konfo_orderReceivedInfo",
            alternative: "Ihre Bestellung wurde an owayo übermittelt.<br> Sie erhalten demnächst eine Bestätigung per Email."
        },
        buttons: [DIALOGPARTS.BUTTONS.CONTINUE_TO_PAYMENT]
    },

    emailNotValid: {
        cssClass: "notice warning badEmail",
        title: DIALOGPARTS.TITLES.WARNING,
        message: {id: "konf_badEmail", alternative: "Die E-Mail-Adresse ist leider nicht korrekt."},
        buttons: [DIALOGPARTS.BUTTONS.OK]
    },
    telefonNrNotValid: {
        cssClass: "notice warning badEmail",
        title: DIALOGPARTS.TITLES.WARNING,
        message: {id: "konf_badTelefonNr", alternative: "Die Telefonnummer ist leider nicht valide."},
        buttons: [DIALOGPARTS.BUTTONS.OK]
    },

    ansprechpartnerNeeded: {
        cssClass: "notice warning badEmail",
        title: DIALOGPARTS.TITLES.WARNING,
        message: {id: "konf_AnsprechpartnerNeeded", alternative: "Bitte geben Sie Ihren Namen für die Bestellung an."},
        buttons: [DIALOGPARTS.BUTTONS.OK]
    },

    emailsNotMatching: {
        cssClass: "notice warning badEmail",
        title: DIALOGPARTS.TITLES.WARNING,
        message: {id: "konf_MailDiffers", alternative: "Die E-Mail-Adressen stimmen nicht überein."},
        buttons: [DIALOGPARTS.BUTTONS.OK]
    },
    pleaseFillMarkedAdressFields: {
        cssClass: "notice warning badEmail",
        title: DIALOGPARTS.TITLES.WARNING,
        message: {
            id: "pleaseFillMarkedAdressFields",
            alternative: "Bitte füllen Sie alle mit einem Sternchen (*) gekennzeichneten Felder aus."
        },
        buttons: [DIALOGPARTS.BUTTONS.OK]
    },
    noPOBoxesAllowed: {
        cssClass: "notice warning badEmail",
        title: DIALOGPARTS.TITLES.WARNING,
        message: {id: "konf_noPOBoxesAllowed", alternative: "Leider können wir nicht and Postfächer versenden."},
        buttons: [DIALOGPARTS.BUTTONS.OK]
    },
    pleaseEnterNumber: {
        cssClass: "notice warning badEmail",
        title: DIALOGPARTS.TITLES.WARNING,
        message: {
            id: "konf_EnterTelnumber",
            alternative: "Bitte geben Sie für die Bestellung eine Telefonnummer an unter der wir Sie erreichen können."
        },
        buttons: [DIALOGPARTS.BUTTONS.OK]
    },


    emailChanged: {
        cssClass: "notice",
        title: DIALOGPARTS.TITLES.OK,
        message: {id: "konf_emailchanged", alternative: "Ihre Email Adresse wurde geändert."},
        buttons: [DIALOGPARTS.BUTTONS.OK]
    },
    emailChangeFailed: {
        cssClass: "notice",
        title: DIALOGPARTS.TITLES.WARNING,
        message: {
            id: "konf_emailchangeError",
            alternative: "Beim Ändern Ihrer Email Adresse ist ein Fehler aufgetreten"
        },
        buttons: [DIALOGPARTS.BUTTONS.OK]
    },
    partNotDroppable: {
        cssClass: "notice partNotDroppable",
        title: DIALOGPARTS.TITLES.WARNING,
        message: {
            id: "konf_notDroppablePart",
            alternative: "Auf diesen Part dürfen sie leider keine Texte oder Logos legen."
        },
        buttons: [DIALOGPARTS.BUTTONS.OK]
    },
    noExemplaries: {
        cssClass: "notice warning badEmail",
        title: DIALOGPARTS.TITLES.WARNING,
        message: {
            id: "konf_noExemplaries",
            alternative: "Es fehlen noch die Exemplardaten (Größen und Aufschriften) fürmindestens einen Artikel!"
        },
        buttons: [DIALOGPARTS.BUTTONS.OK]
    },
    noLieferadresse: {
        cssClass: "notice warning badEmail",
        title: DIALOGPARTS.TITLES.WARNING,
        message: {id: "konf_LieferadresseMissing", alternative: "Sie müssen noch eine Lieferadresse angeben."},
        buttons: [DIALOGPARTS.BUTTONS.OK]
    },
    noRechnungsadresse: {
        cssClass: "notice warning badEmail",
        title: DIALOGPARTS.TITLES.WARNING,
        message: {id: "konf_RechnungsadresseMissing", alternative: "Sie müssen noch eine Rechnungsadresse angeben."},
        buttons: [DIALOGPARTS.BUTTONS.OK]
    },
    amountIsZero: {
        cssClass: "notice warning badEmail",
        title: DIALOGPARTS.TITLES.WARNING,
        message: {
            id: "konf_AmountIsZero",
            alternative: "Sie haben Artikel mit einer Menge von 0. Bitte gehen Sie in die Exemplardaten oder löschen Sie den Artikel."
        },
        buttons: [DIALOGPARTS.BUTTONS.OK]
    },
    noSizeSelected: {
        cssClass: "notice warning badEmail",
        title: DIALOGPARTS.TITLES.WARNING,
        message: {id: "konf_NoSizeSelected", alternative: "Bitte geben Sie eine Größe für die Exemplare an."},
        buttons: [DIALOGPARTS.BUTTONS.OK]
    },
    noItemsInBasket: {
        cssClass: "notice warning",
        title: DIALOGPARTS.TITLES.WARNING,
        message: {id: "konf_noItemsInBasket", alternative: "Sie haben noch keine Artikel in ihrem Warenkorb."},
        buttons: [DIALOGPARTS.BUTTONS.OK]
    },
    draftInBasket: {
        cssClass: "notice warning",
        title: DIALOGPARTS.TITLES.WARNING,
        message: {
            id: "konf_draftInBasket",
            alternative: "Der Entwurf kann nicht gelöscht werden. Er wurde bereits bestellt oder ist derzeit in Ihrem Warenkorb."
        },
        buttons: [DIALOGPARTS.BUTTONS.OK]
    },
    featureNotAllowed: {
        cssClass: "notice warning",
        title: DIALOGPARTS.TITLES.WARNING,
        message: {
            id: "konf_error_featureCombinationNotPossible",
            alternative: "Diese Feature Kombination ist nicht erlaubt."
        },
        buttons: [DIALOGPARTS.BUTTONS.OK]
    },
    confirmLogoDeletion: {
        cssClass: "confirmLogoDeletion bordered",
        title: {id: "konf_deleteLogo_title", alternative: "Logo löschen"},
        message: {
            id: "konf_deleteLogo_message",
            alternative: "Wollen Sei das Logo wirklich löschen? In den Entwürfen in denen es " +
                "verwendet wird wird es weiterhin angezeigt werden."
        },
        buttons: [DIALOGPARTS.BUTTONS.OK, DIALOGPARTS.BUTTONS.CANCEL]
    },
    confirmDraftDeletion: {
        cssClass: "confirmLogoDeletion bordered",
        title: {id: "konf_deleteDraft_title", alternative: "Entwurf löschen"},
        message: {
            id: "konf_deleteDraft_message",
            alternative: "Wollen Sei den Entwurf wirklich löschen?"
        },
        buttons: [DIALOGPARTS.BUTTONS.OK, DIALOGPARTS.BUTTONS.CANCEL]
    },

    duplicateOnCounterpart: {
        cssClass: "notice",
        title: {id: "konf_duplicateOnCounterpart_title", alternative: "Duplizieren auf Gegenpart?"},
        message: {
            id: "konf_duplicateOnCounterpart_message",
            alternative: "Soll das Objekt auf dem Gegenpart dupliziert werden? Dabei wird probiert die " +
                "Größe, Position und Rotation möglichst genau an den Gegenpart anzupassen."
        },
        buttons: [DIALOGPARTS.BUTTONS.YES, DIALOGPARTS.BUTTONS.NO]
    },

    textsNotChecked: {
        cssClass: "notice warning badEmail",
        title: DIALOGPARTS.TITLES.WARNING,
        message: {
            id: "konf_checkTexts",
            alternative: "Bitte treffen Sie für alle Texte eine Zuordnung und entscheiden Sie ob der Text auf allen " +
                "Einzelexemplaren gleich (.z.B. Teamname) oder unterschiedlich (z.b. Spieler- /Fahrername) ist."
        },
        buttons: [DIALOGPARTS.BUTTONS.OK]
    },
    shareOnFacebook: {
        cssClass: "notice shareOnFacebookNow",
        title: {id: "konf_shareNowTitle", alternative: "Jetzt teilen"},
        message: {
            id: "konf_shareNowMessage",
            alternative: "Ihr Design wurde für das Teilen auf Facebook aufbereitet, zeigen Sie ihn Ihren Freunden!"
        },
        buttons: [DIALOGPARTS.BUTTONS.OK, DIALOGPARTS.BUTTONS.CANCEL]
    },
    warningCommentsExist: {
        cssClass: "notice commentWarning",
        title: {id: "konf_pleaseNote", alternative: "Bitte beachten Sie:"},
        message: {
            id: "konf_commentWarning",
            alternative: "Die Kommentare werden nicht auf den neuen Entwurf übertragen!"
        },
        buttons: [DIALOGPARTS.BUTTONS.OK, DIALOGPARTS.BUTTONS.CANCEL]
    },
    noCookieWarning: {
        cssClass: "notice Cookiewarning",
        title: {id: "konf_yourCookiesAreDisabled", alternative: "Leider sind Cookies nicht erlaubt"},
        message: {
            id: "konf_cookiesDisabledMessage",
            alternative: "Für einige der Funktionen dieses Konfigurators werden Cookies benötigt.<br>"
                + "Bitte erlauben Sie die Verwendung von Cookies und laden Sie den Konfigurator neu."
        },
        buttons: [DIALOGPARTS.BUTTONS.OK]
    },
    draftInShop: {
        cssClass: "warning",
        title: DIALOGPARTS.TITLES.WARNING,
        message: {
            id: "konf_draftInShop",
            alternative: "Der Entwurf kann nicht gelöscht werden. Er wird derzeit in einem Shop verwendet."
        },
        buttons: [DIALOGPARTS.BUTTONS.OK]
    },
    draftIsRdyDesign: {
        cssClass: "warning",
        title: DIALOGPARTS.TITLES.WARNING,
        message: {
            id: "konf_draftIsRdyDesign",
            alternative: "Der Entwurf kann nicht gelöscht werden. Es handelt sich um ein Readydesign."
        },
        buttons: [DIALOGPARTS.BUTTONS.OK]
    },
    ki_keine_stilrichtung: {
        cssClass: "warning",
        title: DIALOGPARTS.TITLES.WARNING,
        message: {id: "ki_logoersteller_fehler_keine_stilrichtung", alternative: "Bitte wählen Sie eine Stilrichtung."},
        buttons: [DIALOGPARTS.BUTTONS.OK]
    },
    ki_keine_credits: {
        cssClass: "warning",
        title: DIALOGPARTS.TITLES.WARNING,
        message: {
            id: "ki_allcredits_used",
            alternative: "Sie haben bereits alle Ihnen zur Verfügung stehende Versuche genutzt."
        },
        buttons: [DIALOGPARTS.BUTTONS.OK]
    },
    ki_logoersteller_timeout: {
        cssClass: "warning",
        title: DIALOGPARTS.TITLES.WARNING,
        message: {
            id: "ki_logoersteller_timeout",
            alternative: "Oops, da ist was schief gegangen. Die Logoerstellung dauert zu lange. Bitte probieren Sie es später nochmal."
        },
        buttons: [DIALOGPARTS.BUTTONS.OK]
    },
    ki_logoersteller_abgebrochen: {
        cssClass: "warning",
        title: DIALOGPARTS.TITLES.WARNING,
        message: {
            id: "ki_logoersteller_abgebrochen",
            alternative: "Es ist ein Fehler aufgetreten, Ihr Logo konnte nicht erstellt werden."
        },
        buttons: [DIALOGPARTS.BUTTONS.OK]
    },
    ki_logoersteller_abgebrochen_content: {
        cssClass: "warning",
        title: DIALOGPARTS.TITLES.WARNING,
        message: {
            id: "ki_logoersteller_abgebrochen_content",
            alternative: "Ihr Anfrage konnte nicht bearbeitet werden, weil der Inhalt Ihrer Anfrage die Richtlinien der KI verletzt."
        },
        buttons: [DIALOGPARTS.BUTTONS.OK]
    },
    ki_weitere_anfargen: {
        cssClass: "notice",
        title: DIALOGPARTS.TITLES.HINWEIS,
        message: {
            id: "ki_logoersteller_erklaerung_anzahl_weitere_logos",
            alternative: "Die Erstellung von KI-Logos ist aufwändig. Deshalb kann bei uns jeder User nur 10 eigene KI-Logos kostenlos erstellen. Wenn Sie etwas bei uns bestellen, schalten wir Ihnen weitere Credits für die Logoerstellung frei. Alternativ können Sie kostenlos aus allen KI-Logos auswählen, die bisher bei uns erstellt wurden. Wenn Sie gerne viele eigene KI-Logos erstellen möchten, raten wir Ihnen, sich einen eigenen Account bei einem Anbieter für KI anzulegen und dort Ihre Logos zu erstellen."
        },
        buttons: [DIALOGPARTS.BUTTONS.OK]
    },
    deprecatedProduct: {
        cssClass: "notice deprecatedProduct",
        title: {id: "konf_thisProductIsDeprecatedTitle", alternative: "Jetzt wirds ultraleicht"},
        message: {
            id: "konf_thisProductIsDeprecatedMessage",
            alternative: "Unsere Lauftrikots wurden in ihrer Passform verbessert und werden jetzt aus besonders " +
                "leichtem Run-Tex hergestellt. Wollen Sie Ihr Design auf das neue Produkt " +
                "__replacedBy__ übertragen oder möchten Sie beim alten Lauftrikot bleiben? "
        },
        buttons: [
            {
                text: {id: "konf_keepDeprecatedProduct", alternative: "mit diesem Produkt weiterarbeiten"},
                closeAfter: true
            },
            {
                text: {id: "konf_openChooseProductDialog", alternative: "Produktübersicht"},
                closeAfter: true
            }
        ]
    },
    PDFReady: {
        cssClass: "notice",
        title: {id: "konf_pdfready_title", alternative: "Designansicht bereit"},
        message: {id: "konf_pdfready_message", alternative: "Ihre Designvoransicht ist bereit!"},
        buttons: [
            {
                text: {id: "konf_pdfready_linktext", alternative: "Designansicht öffnen"},
                closeAfter: true
            }
        ]
    },
    BESTELLDATUM_INFO: {
        cssClass: "notice bestellbutton-info",
        title: {id: "konf_bestelltermin_erklaerung_header", alternative: "Informationen zum Bestelltermin"},
        message:
            [
                {
                    id: "konf_bestelltermin_erklaerung_p1",
                    alternative: "Bis zu diesem Zeitpunkt müssen Sie die Bestellung absenden, " +
                        "damit wir den ausgewählten Liefertermin zu den angegebenen Konditionen einghalten können."
                },
                {
                    id: "konf_bestelltermin_erklaerung_p2", alternative: "Sobald wir Ihre Bestellung erhalten haben, " +
                        "wird diese von uns geprüft, (z. B. Qualität der Logos). Auf Wunsch führen wir eine " +
                        "Designberatung durch. Sie erhalten eine ausführliche Auftragszusammenfassung zur Kontrolle. " +
                        "Der Auftrag wird erst produziert, wenn Sie die ihn zur Produktion freigeben."
                },
                {
                    id: "konf_bestelltermin_erklaerung_p3",
                    alternative: "Auch die Produktionsfreigabe muss rechtzeitig erfolgen. " +
                        "Den letztmöglichen Freigabetermin erfahren sie spätestens, wenn Sie die Bestellung absenden."
                },
            ],
        buttons: [
            DIALOGPARTS.BUTTONS.BACKTOBASKET
        ]
    },
    speedDesigncheckExplanation: {
        cssClass: "notice",
        title: {id: "konfi_bestellen_speeddesigncheck_title", alternative: "Speed-Designcheck"},
        message: {
            id: ""
        }
    },
    designcheckNotChosen: {
        cssClass: "warning",
        title: {id: "konfi_bestellen_designcheck_vergessen_title", alternative: "Designcheck auswählen"},
        message: {id: "konfi_bestellen_designcheck_vergessen_text", alternative: "please choose a designcheck option"},
        buttons: [DIALOGPARTS.BUTTONS.OK]
    },
    denyOrder: {
        cssClass: "warning",
        title: DIALOGPARTS.TITLES.WARNING,
        message: {id: "lieferzeitDerzeitNichtLieferbar", alternative: "Derzeit nicht lieferbar!"},
        buttons: [DIALOGPARTS.BUTTONS.OK]
    },
    deleteObjectOutOfDruckbereich: {
        cssClass: "notice noclosebutton",
        title: {id: "konf_deleteNotVisibleObjectTitle", alternative: "Soll das Objekt gelöscht werden?"},
        message: {id: "konf_deleteNotVisibleObject", alternative: "Das Objekt ist nicht mehr im Druckbereich"},
        buttons: [DIALOGPARTS.BUTTONS.DELETE, DIALOGPARTS.BUTTONS.UNDO]
    }

    ////////////////////////////////////
    // Template:
    ////////////////////////////////////
    // DIALOGNAME: {
    // cssClass : "notice",
    // title    : {id: "konf_", alternative: ""},
    // message   : {id: "konf_", alternative : ""},
    // buttons  : [DIALOGPARTS.BUTTONS.OK]
    // }

}
